import { getIsPermittedWithAnyOfThesePermissions, getIsPermittedWithNoneOfThesePermissions } from '../common/classes/permissions';
const checkCabinetPermissions = (cabinet, user) => {
  const {
    denyPermissions = [],
    allowPermissions = []
  } = cabinet;
  // Check deny permissions first
  if (denyPermissions.length > 0) {
    if (!getIsPermittedWithNoneOfThesePermissions(denyPermissions, user)) {
      return false;
    }
  }
  // Check allow permissions
  if (allowPermissions.length > 0) {
    return getIsPermittedWithAnyOfThesePermissions(allowPermissions, user);
  }
  // If no specific permissions defined, allow by default
  return true;
};
export default checkCabinetPermissions;